import { destroy,mutate,query, update } from "../../defaults/fetch";
import {useState,useEffect} from "react";





// STEP

export const useGetAllSteps = (flag)=>{
    const [steps,setSteps] = useState([]);
    const [loading,setLoading] = useState(false);

    useEffect(()=>{
        const getAllSteps = async ()=>{
            setLoading(true);
            const url = `step/all`;
            const {data} = await query(url);
            setLoading(false);
            setSteps(data);
        }
        getAllSteps();
    },[flag]);
    return {
        loading,steps
    }
}


export const useCreateStep = ()=>{
    const createStep = async (body)=>{
        const url = `step/create`;
        const {message} = await mutate(url,true,body);
        return message;
    };
    return createStep;
}


export const useUpdateStep = ()=>{
    const updateStep = async (id,body)=>{
        const url = `step/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateStep;
}


export const useDeleteStep = ()=>{
    const deleteStep = async (id)=>{
        const url = `step/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteStep;
}




// LEVEL

export const useGetAllLevels = (flag, structure)=>{
    const [levels,setLevels] = useState([]);
    const [loading,setLoading] = useState(false);

    useEffect(()=>{
        const getAllLevels = async ()=>{
            setLoading(true);
            const url = `level/all`;
            const qs = {
                structure: structure
            }
            const {data} = await query(url, qs);
            setLoading(false);
            setLevels(data);
        }
        getAllLevels();
    },[flag, structure]);
    return {
        loading,levels
    }
}


export const useCreateLevel = ()=>{
    const createLevel = async (body)=>{
        const url = `level/create`;
        const {message} = await mutate(url,true,body);
        return message;
    };
    return createLevel;
}


export const useUpdateLevel = ()=>{
    const updateLevel = async (id,body)=>{
        const url = `level/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateLevel;
}


export const useDeleteLevel = ()=>{
    const deleteLevel = async (id)=>{
        const url = `level/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteLevel;
}




// BENEFIT

export const useGetAllBenefits = (flag)=>{
    const [benefits,setBenefits] = useState([]);
    const [loading,setLoading] = useState(false);

    useEffect(()=>{
        const getAllBenefits = async ()=>{
            setLoading(true);
            const url = `benefit/all`;
            const {data} = await query(url);
            setLoading(false);
            setBenefits(data);
        }
        getAllBenefits();
    },[flag]);
    return {
        loading,benefits
    }
}


export const useGetAllBenefitScopes = (flag)=>{
    const [scopes,setScopes] = useState([]);
    const [loading,setLoading] = useState(false);

    useEffect(()=>{
        const getAllBenefitScopes = async ()=>{
            setLoading(true);
            // const url = `system/get-benefit-scopes`;
            // const {data} = await query(url);
            setLoading(false);
            setScopes([]);
        }
        getAllBenefitScopes();
    },[flag]);

    return{
        loading,scopes
    }
}


export const useCreateBenefit = ()=>{
    const createBenefit = async (body)=>{
        const url = `benefit/create`;
        const {message} = await mutate(url,true,body);
        return message;
    };
    return createBenefit;
}


export const useUpdateBenefit = ()=>{
    const updateBenefit= async (id,body)=>{
        const url = `benefit/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateBenefit;
}


export const useDeleteBenefit = ()=>{
    const deleteBenefit = async (id)=>{
        const url = `benefit/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteBenefit;
}


// DEDUCTION

export const useGetAllDeductions = (flag)=>{
    const [deductions,setDeductions] = useState([]);
    const [loading,setLoading] = useState(false);

    useEffect(()=>{
        const getAllDeductions = async ()=>{
            setLoading(true);
            const url = `deduction/all`;
            const {data} = await query(url);
            setLoading(false);
            setDeductions(data);
        }
        getAllDeductions();
    },[flag]);
    return {
        loading,deductions
    }
}


export const useCreateDeduction = ()=>{
    const createDeduction = async (body)=>{
        const url = `deduction/create`;
        const {message} = await mutate(url,true,body);
        return message;
    };
    return createDeduction;
}


export const useUpdateDeduction = ()=>{
    const updateDeduction= async (id,body)=>{
        const url = `deduction/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateDeduction;
}


export const useDeleteDeduction = ()=>{
    const deleteDeduction = async (id)=>{
        const url = `deduction/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteDeduction;
}
